import { Cassette } from "@/pages/catalogs/models/Cassette";
import { ErrorModal } from "@dexteel/mesf-core";
import { Grid2, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Part } from "../../models/Part";
import { getCassettes } from "../../repositories/parts/CassetteRepository";

type useCassettesProps = {
	partId: number;
	onError: (error: Error) => void;
	onSuccess?: (data: Cassette[]) => void;
};

export const useCassettes = ({
	partId,
	onError,
	onSuccess,
}: useCassettesProps) => {
	return useQuery<Cassette[], Error>({
		queryKey: ["cassettes", partId],
		meta: { realtime: ["M2.GetCassettes"] },
		queryFn: ({ signal }) => getCassettes({ partId }, signal),
		onError: onError,
		onSuccess: onSuccess,
	});
};

type Props = {
	part: Part | null;
};

export const SpecificCassetteData = ({ part }: Props) => {
	const [error, setError] = useState("");
	const [cassette, setCassette] = useState<Cassette>();

	const { data: cassettes } = useCassettes({
		partId: part?.PartId!,
		onError: (error) => setError(error.message),
		onSuccess: (data: Cassette[]) => {
			setCassette(data[0]);
		},
	});

	return (
		<>
			<Grid2 container spacing={1}>
				<Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
					<TextField
						value={cassette?.Stands || ""}
						label="Stands"
						variant="outlined"
						size="small"
						fullWidth
						disabled
					/>
				</Grid2>
				<Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
					<TextField
						value={cassette?.Sections || ""}
						label="Sections"
						variant="outlined"
						size="small"
						fullWidth
						disabled
					/>
				</Grid2>
				<Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
					<TextField
						value={cassette?.RivCassetteChockName || ""}
						label="River Cassette Chock"
						variant="outlined"
						size="small"
						fullWidth
						disabled
					/>
				</Grid2>
				<Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
					<TextField
						value={cassette?.AveCassetteChockName || ""}
						label="Avenue Cassette Chock"
						variant="outlined"
						size="small"
						fullWidth
						disabled
					/>
				</Grid2>
			</Grid2>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
